export enum PhotoGalleryEvents {
	DELETE_IMAGE = 'deleteImage',
	SELECT_IMAGE = 'selectImage',
	IMAGE_DELETED = 'imageDeleted',
	CHANGE_IMAGE = 'changeImage',
	ROTATE_IMAGE = 'rotateImage',
	DRAW_FORMS = 'drawForms',
}
